/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="93.68"
        height="95.83"
        viewBox="0 0 93.68 95.83"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M17.57 66.02H3.26A3.26 3.26 0 0 0 0 69.28v23.29a3.26 3.26 0 0 0 3.26 3.26h14.31a3.26 3.26 0 0 0 3.26-3.26V69.28a3.26 3.26 0 0 0-3.26-3.26ZM3.26 68.5h14.31a.76.76 0 0 1 .76.76v23.29a.76.76 0 0 1-.76.76H3.26a.76.76 0 0 1-.76-.76V69.28a.76.76 0 0 1 .76-.78ZM53.92 52.19H39.64a3.28 3.28 0 0 0-3.28 3.31v37.09a3.27 3.27 0 0 0 3.28 3.27h14.28a3.27 3.27 0 0 0 3.28-3.27V55.5a3.28 3.28 0 0 0-3.28-3.31Zm-14.28 2.5h14.28a.78.78 0 0 1 .78.78v37.09a.77.77 0 0 1-.78.77H39.64a.77.77 0 0 1-.78-.77V55.5a.78.78 0 0 1 .78-.81ZM90.43 20.19H76.1a3.24 3.24 0 0 0-3.25 3.25v69.14a3.24 3.24 0 0 0 3.25 3.25h14.33a3.24 3.24 0 0 0 3.25-3.25V23.44a3.24 3.24 0 0 0-3.25-3.25Zm-14.33 2.5h14.33a.74.74 0 0 1 .75.75v69.14a.74.74 0 0 1-.75.75H76.1a.74.74 0 0 1-.75-.75V23.44a.74.74 0 0 1 .75-.75Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M58.19 0a1.5 1.5 0 0 1 1.49 1.36v14.22a1.502 1.502 0 0 1-3 .15V3H43.83a1.49 1.49 0 0 1-1.49-1.36V1.5A1.5 1.5 0 0 1 43.7.01h14.5Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M57.12.44a1.5 1.5 0 0 1 2.23 2l-.1.11-31.64 31.79a1.5 1.5 0 0 1-2.23-2l.1-.11Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'BarChartWithUpwardArrowIcon';

export default Icon;
